import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import ImportScreen from './screens/ImportScreen';
import SchedulerScreen from './screens/SchedulerScreen';
import ContractorsScreen from './screens/ContractorsScreen';
import ExportScreen from './screens/ExportScreen';
import { AppProvider } from './contexts/AppContext';
import { AnimatePresence } from 'framer-motion';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate initial load
    setTimeout(() => setLoading(false), 1000);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-ops-bg-primary">
        <div className="text-center">
          <div className="relative w-32 h-32 mx-auto mb-4">
            <div className="absolute inset-0 border-4 border-ops-accent-primary border-t-transparent rounded-full animate-spin"></div>
            <div className="absolute inset-2 border-4 border-ops-accent-secondary border-b-transparent rounded-full animate-spin animation-delay-150"></div>
            <div className="absolute inset-4 border-4 border-ops-gradient-end border-r-transparent rounded-full animate-spin animation-delay-300"></div>
          </div>
          <h1 className="text-2xl font-bold text-ops-text-primary mb-2">IQCrew Scheduler</h1>
          <p className="text-ops-text-secondary">Initializing System...</p>
        </div>
      </div>
    );
  }

  return (
    <AppProvider>
      <Router>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/import" replace />} />
              <Route path="import" element={<ImportScreen />} />
              <Route path="scheduler" element={<SchedulerScreen />} />
              <Route path="contractors" element={<ContractorsScreen />} />
              <Route path="export" element={<ExportScreen />} />
            </Route>
          </Routes>
        </AnimatePresence>
      </Router>
    </AppProvider>
  );
}

export default App;
